var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscussionForums(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#2c73db}.cls-3{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    style: {
      fill: "#bddbff"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15,
    cy: 15,
    r: 12.78
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.56 9.86v7.32h5.51L19.62 20v-2.82h1.75V9.86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.37 17.88h-5.5v-4.34H8.22v6.27h1.5v2.45l2.18-2.45h4.71v-1.66zm-1.05-2.61-.26-1.13-.26 1.13h-.89l-.63-2.98h.91l.22 1.2.27-1.2h.76l.27 1.21.22-1.21h.91l-.64 2.98h-.88z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m16.68 12.41-.58 2.73h-.68l-.36-1.55-.36 1.55H14l-.58-2.73h.65l.31 1.72.38-1.72h.56l.38 1.72.3-1.72h.65m.31-.25h-1.14v.21l-.09.5-.11-.51v-.2h-1l-.05.2-.11.5-.08-.49v-.21h-1.25l.06.31.58 2.73v.19h1.13v-.19l.12-.51.12.51v.19h1.09v-.19l.58-2.73.06-.31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m18.66 15.27-.27-1.13-.26 1.13h-.88l-.63-2.98h.91l.22 1.2.26-1.2h.76l.27 1.21.22-1.21h.91l-.63 2.98h-.88z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m20 12.41-.58 2.73h-.68l-.37-1.55-.37 1.55h-.68l-.58-2.73h.66l.31 1.72.37-1.72h.56l.38 1.72.32-1.72H20m.31-.25h-1.15v.21l-.09.5-.11-.51-.05-.2h-1v.2l-.11.5-.09-.49v-.21h-1.25l.07.31.58 2.73v.19h1.08l.05-.19.11-.51.12.51v.19h1.08l.05-.19.57-2.73.07-.31z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m22 15.27-.27-1.13-.26 1.13h-.88l-.64-2.98h.92l.22 1.2.26-1.2h.76l.27 1.21.22-1.21h.91l-.63 2.98H22z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.36 12.41-.58 2.73h-.68l-.37-1.55-.36 1.55h-.68l-.58-2.73h.65l.32 1.72.37-1.72H22l.38 1.72.31-1.72h.66m.31-.25H22.5v.21l-.09.5-.12-.51v-.2h-1v.2l-.11.5-.18-.49v-.21h-1.2l.07.31.58 2.73v.19h1.08l.05-.19.11-.51.12.51v.19H23v-.19l.58-2.73.07-.31z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussionForums);
export default __webpack_public_path__ + "static/media/DiscussionForums.fbaff5e49857cb63985d4cf5ef7d9af0.svg";
export { ForwardRef as ReactComponent };